<template>
  <v-card class="d-flex pa-2 mb-2 flex-column align-center">
    <span>{{ $t('components.fileUploader.uploading') }} {{ filename }}</span>
    <v-progress-linear
      class="my-4"
      :value="progress"
    />
  </v-card>
</template>

<script>
export default {
  props: {
    filename: {
      type: String,
      required: true,
    },
    progress: {
      type: Number,
      required: true,
    },
  },
};
</script>
